<template>
  <LayoutAuth>
    <div class="mx-auto max-w-md">
      <h1 class="h1-auth max-w-sm">Login en ga aan de slag!</h1>
      <div v-if="mailSent">
        <h2>
          <h2 class="flex items-center text-2xl mb-3">
            <BaseIcon name="mail" class="mr-2 text-gray-500" width="24" height="24" />
            <span>Check your email!</span>
          </h2>
          <p class="text-gray-500 max-w-md leading-normal">
            We've sent you an
            <span class="text-gray-600">email with instructions</span> to reset your password.
          </p>
        </h2>
      </div>
      <form v-else ref="form" method="POST" @submit.prevent>
        <div class="mb-4">
          <label for="email" class="mb-2 block">E-mailadres</label>
          <BaseInput
            name="email"
            id="email"
            type="email"
            v-model="form.email"
            :error="errors.email"
            @input="errors.email = false"
            required
            v-focus
          />
        </div>
        <div class="mb-4">
          <label for="password" class="mb-2 block">Wachtwoord</label>
          <BaseInput
            name="password"
            id="password"
            v-model="form.password"
            :error="errors.password"
            @input="errors.password = false"
            type="password"
            required
          />
        </div>
        <div class="mb-6">
          <BaseCheckbox name="remember" v-model="form.remember">Ingelogd blijven</BaseCheckbox>
        </div>
        <div class="flex">
          <button type="submit" @click.prevent="submit" class="btn btn-blue shadow">Login</button>
          <router-link :to="{ name: 'password.reset' }" class="cancel">Wachtwoord vergeten?</router-link>
        </div>
      </form>
    </div>
  </LayoutAuth>
</template>

<script>
import auth from "@/auth";
import {
  convertServerErrors,
  grabValidityErrors,
  focusFirstError
} from "@/functions";
import LayoutAuth from "@/components/LayoutAuth";

export default {
  metaInfo() {
    return { title: "Login" };
  },

  data() {
    return {
      form: {
        email: "",
        password: "",
        remember: false
      },
      errors: {},
      mailSent: false
    };
  },

  components: {
    LayoutAuth
  },

  methods: {
    submit() {
      let form = this.$refs.form;

      if (!form.checkValidity()) {
        this.setErrors(grabValidityErrors(form));
        return;
      }

      let credentials = { ...this.form };

      auth
        .login(credentials)
        .then(user => {
          if (user.redirect) {
            window.location.href = user.redirect;
          } else {
            this.$router.push({ name: "dashboard" });
          }
        })
        .catch(error => {
          this.setErrors(convertServerErrors(error.response));
          auth.csrf();
        });
    },

    setErrors(errors) {
      this.$set(this, "errors", errors);
      focusFirstError();
    }
  }
};
</script>
